import React, { useEffect, useState } from "react";
import { Row, Col, Container, Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

//img
import logo from "../../../assets/images/logo/logo.png";
import login1 from "../../../assets/images/login/1.jpg";
import login2 from "../../../assets/images/login/2.jpg";
import login3 from "../../../assets/images/login/3.jpg";
import "./style.css";
// Import selectors & action from setting store
import * as SettingSelector from "../../../store/setting/selectors";

// Redux Selector / Action
import { useSelector } from "react-redux";
import axios from "axios";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const SignUp = () => {
  const appName = useSelector(SettingSelector.app_name);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    gender: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    fatherName: "",
    motherName: "",
    institution_name: "",
    adm_no: "",
    contactNumber: "",
  });
  console.log(formData, "/////////////////////////////");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => {
      const updatedForm = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };

      console.log("Updated Form Data:", updatedForm); // 👈 Logs updated form state
      return updatedForm;
    });
  };

  // validation my inputs
  const validateForm = () => {
    const requiredFields = {
      fullName: "Full Name",
      email: "Email",
      gender: "Gender",
      dob: "",
      address: "Address",
      city: "City",
      state: "City",
      pincode: "896464",
      fatherName: "Father's Name",
      motherName: "Mother's Name",
      contactNumber: "",
      institution_name: "School ID",
      adm_no: "School ID",
    };

    const missingFields = [];

    for (let key in requiredFields) {
      const value = formData[key];
      if (!value) {
        missingFields.push(requiredFields[key]);
      }
    }

    if (missingFields.length > 0) {
      toast.error(`Please fill in: ${missingFields.join(", ")}`);
      return false;
    }

    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if contactNumber is greater than 10 digits
    if (formData.contactNumber.length > 10) {
      toast.error("Contact number cannot be more than 10 digits.");
      return; // Prevent further execution if the number is invalid
    }

    try {
      const response = await axios.post(webServiceUrl.register, formData);

      console.log(response.data);

      if (response.data.success) {
        // Show the success toast
        toast.success("Registration successful!");
        setTimeout(() => {
          navigate("/auth/sign-in");
        }, 1000); // 1000ms = 1 second
        // Reset form data after successful registration
        setFormData({
          fullName: "",
          email: "",
          gender: "",
          dob: "",
          address: "",
          city: "",
          state: "",
          pincode: "",
          fatherName: "",
          motherName: "",
          institution_name: "",
          adm_no: "",
          contactNumber: "",
        });
      } else {
        console.log("Error:", response.data.message);
        toast.error(response.data.message); // Show error toast if registration fails
      }
    } catch (error) {
      console.error("Error during registration:", error);
      toast.error("All fields are required", error);
    }
  };

  return (
    <>
      <section className="sign-in-page">
        <Container fluid>
          <Row className="">
            <Col md={6} className="overflow-hidden position-relative">
              <div className="bg-primary w-100 h-100 position-absolute top-0 bottom-0 start-0 end-0"></div>
              <div className="container-inside z-1">
                <div className="main-circle circle-small"></div>
                <div className="main-circle circle-medium"></div>
                <div className="main-circle circle-large"></div>
                <div className="main-circle circle-xlarge"></div>
                <div className="main-circle circle-xxlarge"></div>
              </div>
              <div className="sign-in-detail container-inside-top">
                <Swiper
                  className="list-inline m-0 p-0"
                  spaceBetween={30}
                  centeredSlides={true}
                  loop={true}
                  autoplay={{ delay: 2000, disableOnInteraction: false }}
                >
                  <SwiperSlide>
                    <img
                      src={login1}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      Admin Panel for Course Management
                    </h2>
                    <p className="font-size-16 text-white mb-0">
                      We provide a comprehensive platform for managing and
                      delivering courses to students.
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={login2}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      Manage Courses Efficiently
                    </h2>
                    <p className="font-size-16 text-white mb-0">
                      The admin panel allows you to easily manage course content
                      and student access.
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src={login3}
                      className="signin-img img-fluid mb-5 rounded-3"
                      alt="images"
                    />
                    <h2 className="mb-3 text-white fw-semibold">
                      Empower Students with Knowledge
                    </h2>
                    <p className="font-size-16 text-white mb-0">
                      Provide a seamless learning experience with a
                      user-friendly admin panel.
                    </p>
                  </SwiperSlide>
                </Swiper>
              </div>
            </Col>
            <Col md={6}>
              <div
                style={{ maxHeight: "100vh", overflowY: "auto" }}
                className="scrollable-form-container"
              >
                <div className="sign-in-from text-center mt-4">
                  <Link
                    to="/"
                    className="d-inline-flex align-items-center justify-content-center gap-2"
                  >
                    <img src={logo} style={{ height: "90px" }} />
                    {/* <h2 className="logo-title" data-setting="app_name">
                    IHFC
                  </h2> */}
                  </Link>
                  <p className="font-size-18 pb-0 mb-0">
                    <b> Sign up to get started</b>
                  </p>
                  <Form className="mt-5" onSubmit={handleSubmit}>
                    {/* Full Name and Email */}
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <label
                            htmlFor="fullName"
                            className="form-label text-start d-block"
                          >
                            Full Name
                          </label>
                          <Form.Control
                            id="fullName"
                            type="text"
                            placeholder="Full Name"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="text-start">
                          <p className="form-label text-start d-block">
                            Gender
                          </p>
                          <div className="d-flex gap-4 bold-radio">
                            {[
                              { value: "M", item: "Male" },
                              { value: "F", item: "Female" },
                              { value: "O", item: "Other" },
                            ].map((g, index) => (
                              <Form.Check
                                key={g.value}
                                id={`gender-${index}`}
                                type="radio"
                                label={g.item}
                                name="gender"
                                value={g.value}
                                checked={formData.gender === g.value}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    gender: e.target.value,
                                  })
                                }
                              />
                            ))}
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                    {/* Gender (Radio Buttons) and City (Dropdown) */}
                    <Row className="">
                      <Col md={6}>
                        <div className="mb-3">
                          <label
                            htmlFor="email"
                            className="form-label text-start d-block"
                          >
                            Date of Birth
                          </label>
                          <Form.Control
                            id="dob"
                            type="Date"
                            placeholder="Date of Birth"
                            name="dob"
                            value={formData.dob}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <label
                            htmlFor="fatherName"
                            className="form-label text-start d-block"
                          >
                            Father's Full Name
                          </label>
                          <Form.Control
                            id="fatherName"
                            type="text"
                            placeholder="Father's Full Name"
                            name="fatherName"
                            value={formData.fatherName}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <label
                            htmlFor="email"
                            className="form-label text-start d-block"
                          >
                            Mother's Maiden Name
                          </label>
                          <Form.Control
                            id="motherName"
                            type="text"
                            placeholder="Mother's Maiden Name"
                            name="motherName"
                            value={formData.motherName}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Password and Confirm Password */}
                    <Row className="">
                      <Col md={6}>
                        <label
                          htmlFor="institution_name"
                          className="form-label text-start d-block"
                        >
                          Institution Name
                        </label>
                        <Form.Control
                          type="text"
                          name="institution_name"
                          placeholder="Institution Name"
                          value={formData.institution_name}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={6}>
                        <label
                          htmlFor="adm_no"
                          className="form-label text-start d-block"
                        >
                          Institution Admission No
                        </label>
                        <Form.Control
                          type="text"
                          name="adm_no"
                          value={formData.adm_no}
                          onChange={handleChange}
                          placeholder="Institution Admission No"
                        />
                      </Col>
                    </Row>

                    {/* Father's Name and Mother's Name */}
                    <Row className="mt-3">
                      <Col md={6}>
                        <label
                          htmlFor="address"
                          className="form-label text-start d-block"
                        >
                          Communication Address
                        </label>
                        <Form.Control
                          as="textarea"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          placeholder="Communication Address"
                        />
                      </Col>
                      <Col md={6}>
                        <label
                          htmlFor="state"
                          className="form-label text-start d-block"
                        >
                          State
                        </label>
                        <Form.Control
                          type="text"
                          name="state"
                          placeholder="State"
                          value={formData.state}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>

                    {/* Address and School Name */}
                    <Row className="mt-3">
                      <Col md={6}>
                        <label
                          htmlFor="city"
                          className="form-label text-start d-block"
                        >
                          City
                        </label>
                        <Form.Control
                          type="text"
                          name="city"
                          placeholder="City"
                          value={formData.city}
                          onChange={handleChange}
                        />
                      </Col>

                      <Col md={6}>
                        <label
                          htmlFor="pincode"
                          className="form-label text-start d-block"
                        >
                          Pincode
                        </label>
                        <Form.Control
                          type="text"
                          name="pincode"
                          placeholder="Pincode"
                          value={formData.pincode}
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>

                    {/* Upload Certificate and School ID */}

                    <Row className="mt-4">
                      <Col md={6}>
                        <label
                          htmlFor="contactNumber"
                          className="form-label text-start d-block"
                        >
                          Parent/Self Mobile Number
                        </label>
                        <Form.Control
                          type="Number"
                          name="contactNumber"
                          placeholder="Parent/Self Mobile Number"
                          value={formData.contactNumber}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <label
                            htmlFor="email"
                            className="form-label text-start d-block"
                          >
                            Email
                          </label>
                          <Form.Control
                            id="email"
                            type="email"
                            placeholder="Email Address"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Submit Button */}

                    <div className="d-flex align-items-center justify-content-between">
                      <Form.Check className="form-check d-inline-block m-0">
                        <Form.Check.Input
                          type="checkbox"
                          className="form-check-input checkbox"
                          name="acceptTerms"
                          checked={formData.acceptTerms}
                          onChange={handleChange}
                        />
                        <h6 className="form-check-label fw-500 font-size-14">
                          I accept Terms and Conditions
                        </h6>
                      </Form.Check>
                    </div>
                    <Button
                      variant="primary"
                      type="submit"
                      className="btn btn-primary mt-4 fw-semibold text-uppercase w-100"
                    >
                      Sign Up
                    </Button>
                    <h6 className="mt-2">
                      Already Have An Account ?{" "}
                      <Link to={"/auth/sign-in"}>Login</Link>
                    </h6>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        {/* 🔔 ToastContainer */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          style={{ fontSize: "13px" }}
        />
      </section>
    </>
  );
};

export default SignUp;

// ********************************************
// import React, { useEffect, useState } from "react";
// import { Row, Col, Container, Form, Button } from "react-bootstrap";
// import { Link } from "react-router-dom";

// //swiper
// import { Swiper, SwiperSlide } from "swiper/react";
// import SwiperCore from "swiper";
// import { Navigation, Autoplay } from "swiper/modules";

// //img
// import logo from "../../../assets/images/logo/logo.png";
// import login1 from "../../../assets/images/login/1.jpg";
// import login2 from "../../../assets/images/login/2.jpg";
// import login3 from "../../../assets/images/login/3.jpg";

// // Import selectors & action from setting store
// import * as SettingSelector from "../../../store/setting/selectors";
// // Redux Selector / Action
// import { useSelector } from "react-redux";

// // install Swiper modules
// SwiperCore.use([Navigation, Autoplay]);

// const SignUp = () => {
//   const appName = useSelector(SettingSelector.app_name);

//   const [selectedDocument, setSelectedDocument] = useState("");

//   const handleDocumentChange = (event) => {
//     setSelectedDocument(event.target.value);
//   };

//   return (
//     <>
//       <section className="sign-in-page">
//         <Container fluid>
//           <Row className="">
//             <Col md={6} className="overflow-hidden position-relative">
//               <div className="bg-primary w-100 h-100 position-absolute top-0 bottom-0 start-0 end-0"></div>
//               <div className="container-inside z-1">
//                 <div className="main-circle circle-small"></div>
//                 <div className="main-circle circle-medium"></div>
//                 <div className="main-circle circle-large"></div>
//                 <div className="main-circle circle-xlarge"></div>
//                 <div className="main-circle circle-xxlarge"></div>
//               </div>
//               <div className="sign-in-detail container-inside-top">
//                 <Swiper
//                   className="list-inline m-0 p-0 "
//                   spaceBetween={30}
//                   centeredSlides={true}
//                   loop={true}
//                   autoplay={{
//                     delay: 2000,
//                     disableOnInteraction: false,
//                   }}
//                 >
//                   <ul className="swiper-wrapper list-inline m-0 p-0 ">
//                     <SwiperSlide>
//                       <img
//                         src={login1}
//                         className="signin-img img-fluid mb-5 rounded-3"
//                         alt="images"
//                       />
//                       <h2 className="mb-3 text-white fw-semibold">
//                         Power UP Your Friendship
//                       </h2>
//                       <p className="font-size-16 text-white mb-0">
//                         It is a long established fact that a reader will be
//                         <br /> distracted by the readable content.
//                       </p>
//                     </SwiperSlide>
//                     <SwiperSlide>
//                       <img
//                         src={login2}
//                         className="signin-img img-fluid mb-5 rounded-3"
//                         alt="images"
//                       />
//                       <h2 className="mb-3 text-white fw-semibold">
//                         Connect with the world
//                       </h2>
//                       <p className="font-size-16 text-white mb-0">
//                         It is a long established fact that a reader will be
//                         <br /> distracted by the readable content.
//                       </p>
//                     </SwiperSlide>
//                     <SwiperSlide>
//                       <img
//                         src={login3}
//                         className="signin-img img-fluid mb-5 rounded-3"
//                         alt="images"
//                       />
//                       <h2 className="mb-3 text-white fw-semibold">
//                         Together Is better
//                       </h2>
//                       <p className="font-size-16 text-white mb-0">
//                         It is a long established fact that a reader will be
//                         <br /> distracted by the readable content.
//                       </p>
//                     </SwiperSlide>
//                   </ul>
//                 </Swiper>
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="sign-in-from text-center mt-4">
//                 <Link
//                   to="/"
//                   className="d-inline-flex align-items-center justify-content-center gap-2"
//                 >
//                   <img src={logo} style={{ height: "90px" }} />
//                   {/* <h2 className="logo-title" data-setting="app_name">
//                     IHFC
//                   </h2> */}
//                 </Link>
//                 <p className="font-size-14 pb-0 mb-0">
//                   <b> Sign up to get started</b>
//                 </p>

//                 <Form className="mt-5">
//                   {/* Row for Full Name and Email */}
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Full Name</h6>
//                         <Form.Control
//                           type="text"
//                           className="form-control mb-0"
//                           placeholder="Full Name"
//                           // defaultValue="marvin shaw"
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Email Address</h6>
//                         <Form.Control
//                           type="email"
//                           className="form-control mb-0"
//                           placeholder="Email Address"
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                   {/* Row for Gender and City */}
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label">Gender</h6>
//                         <div className="d-flex gap-3">
//                           <Form.Check
//                             type="radio"
//                             label="Male"
//                             name="gender"
//                             id="genderMale"
//                           />
//                           <Form.Check
//                             type="radio"
//                             label="Female"
//                             name="gender"
//                             id="genderFemale"
//                           />
//                           <Form.Check
//                             type="radio"
//                             label="Other"
//                             name="gender"
//                             id="genderOther"
//                           />
//                         </div>
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label">Select City</h6>
//                         <Form.Control as="select" className="form-control mb-0">
//                           <option value="">Select City</option>
//                           <option value="new_delhi">New Delhi</option>
//                           <option value="mumbai">Mumbai</option>
//                           <option value="bangalore">Bangalore</option>
//                           <option value="kolkata">Kolkata</option>
//                           <option value="chennai">Chennai</option>
//                           <option value="hyderabad">Hyderabad</option>
//                         </Form.Control>
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   {/* Row for Password and Confirm Password */}
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Password</h6>
//                         <Form.Control
//                           type="password"
//                           className="form-control mb-0"
//                           placeholder="Password"
//                           defaultValue="marvin"
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Confirm Password</h6>
//                         <Form.Control
//                           type="password"
//                           className="form-control mb-0"
//                           placeholder="Confirm Password"
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   {/* Row for Father's Name and Mother's Name */}
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Father's Name</h6>
//                         <Form.Control
//                           type="text"
//                           className="form-control mb-0"
//                           placeholder="Father's Name"
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Mother's Name</h6>
//                         <Form.Control
//                           type="text"
//                           className="form-control mb-0"
//                           placeholder="Mother's Name"
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   {/* Row for Address and School Name */}
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Address</h6>
//                         <Form.Control
//                           type="text"
//                           className="form-control mb-0"
//                           placeholder="Address"
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">School Name</h6>
//                         <Form.Control as="select" className="form-control mb-0">
//                           <option value="">Select a School</option>
//                           <option value="delhiPublicSchool">
//                             Delhi Public School
//                           </option>
//                           <option value="stXaviersSchool">
//                             St. Xavier's School
//                           </option>
//                           <option value="modernSchool">Modern School</option>
//                           <option value="bentleySchool">Bentley School</option>
//                           <option value="harvardSchool">Harvard School</option>
//                           <option value="theHeritageSchool">
//                             The Heritage School
//                           </option>
//                           <option value="blueRidgeSchool">
//                             Blue Ridge School
//                           </option>
//                         </Form.Control>
//                       </Form.Group>
//                     </Col>
//                   </Row>

//                   {/* Row for Upload Document */}
//                   {/* <Form.Group className="form-group text-start">
//   <h6 className="form-label fw-bold">Upload Document</h6>
//   <Form.Control as="select" className="form-control mb-0">
//     <option value="school_id_card">School ID Card</option>
//     <option value="cast_certificate">Cast Certificate</option>
//   </Form.Control>
// </Form.Group> */}
//                   <Row>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Upload Certificate:</h6>
//                         <Form.Control
//                           type="file"
//                           className="form-control mb-0"
//                           placeholder="Choose file"
//                         />
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="form-group text-start">
//                         <h6 className="form-label ">Upload School ID:</h6>
//                         <Form.Control
//                           type="file"
//                           className="form-control mb-0"
//                           placeholder="Choose file"
//                         />
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                   <div className="d-flex align-items-center justify-content-between">
//                     <Form.Check className="form-check d-inline-block m-0">
//                       <Form.Check.Input
//                         type="checkbox"
//                         className="form-check-input"
//                       />
//                       <h6 className="form-check-label fw-500 font-size-14">
//                         I accept{" "}
//                         <Link
//                           className="fw-light ms-1"
//                           to="/dashboard/extrapages/terms-of-service"
//                         >
//                           Terms and Conditions
//                         </Link>
//                       </h6>
//                     </Form.Check>
//                   </div>
//                   <Button
//                     variant="primary"
//                     type="button"
//                     className="btn btn-primary mt-4 fw-semibold text-uppercase w-100"
//                   >
//                     Sign Up
//                   </Button>
//                   <h6 className="mt-2">
//                     Already Have An Account ?{" "}
//                     <Link to={"/auth/sign-in"}>Login</Link>
//                   </h6>
//                 </Form>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };

// export default SignUp;
